module.exports = __webpack_public_path__ + "static/luminous_5-ac1b0b53c84b894f80f2319d02a5a26c.jpg";